import { isFacilityOpen } from "./engine";
import type { EvaluatedToilet } from "./types";

export type ArrivalConfidenceTone = "positive" | "caution" | "critical";

export type ArrivalConfidence = {
  label: string;
  tone: ArrivalConfidenceTone;
  arrivalAt: Date;
};

/**
 * Converts the current evidence into the single question a visitor has while
 * walking: whether the facility is still likely to work when they arrive.
 */
export function getArrivalConfidence(
  item: EvaluatedToilet,
  now: Date,
): ArrivalConfidence {
  const arrivalAt = new Date(now.getTime() + item.walkingMinutes * 60_000);

  if (
    item.state === "unavailable_confirmed" ||
    item.state === "likely_unavailable"
  ) {
    return {
      label: item.reasons[0] ?? "利用困難の情報があります",
      tone: "critical",
      arrivalAt,
    };
  }

  if (item.openingPeriods.length === 0) {
    return {
      label: "到着時の利用時間は未確認",
      tone: "caution",
      arrivalAt,
    };
  }

  if (!isFacilityOpen(item, arrivalAt)) {
    return {
      label: "到着時は利用時間外の見込み",
      tone: "critical",
      arrivalAt,
    };
  }

  if (item.state === "available_confirmed") {
    return { label: "到着時も利用できる見込み", tone: "positive", arrivalAt };
  }
  if (item.state === "available_likely") {
    return { label: "到着時も利用できる可能性が高い", tone: "positive", arrivalAt };
  }
  if (item.state === "limited") {
    return { label: "到着時は利用条件を確認", tone: "caution", arrivalAt };
  }
  return {
    label: "到着時の利用状況は未確認",
    tone: "caution",
    arrivalAt,
  };
}
